<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Başlangıç Tarihi</label>
            <v-date-picker placeholder="Başlangıç Tarihi" v-model="value.StartDate"></v-date-picker>
        </div>
        <div class="col-12 mb-1">
            <span class="text-danger">Bitiş tarihi bilgisi personelin SGK şubesinin tehlike sınıfı değerine göre otomatik olarak kayıttan sonra atanacaktır.</span>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Sağlık Raporu</label>
            <v-file-uploader :accept="['xlsx', 'png', 'jpg', 'doc', 'docx', 'xls', 'pdf', 'jpeg', 'txt']" :value="value" value-parameter="HealthReportFile"></v-file-uploader>
        </div>
        <div class="col-12 mb-1">
            <div class="p-50 border rounded">
                <div class="row">
                    <div class="col-12">
                        <b-form-checkbox v-model="value.DisabledPerson">Engelli</b-form-checkbox>
                    </div>
                    <div class="col-12 my-1" v-if="value.DisabledPerson">
                        <label class="form-label">Engellilik Oranı</label>
                        <input type="number" :disabled="!value.DisabledPerson" class="form-control" v-model="value.DisabilityRate" placeholder="Engellilik Oranı" min="0" max="100" />
                    </div>
                    <div class="col-12" v-if="value.DisabledPerson">
                        <label class="form-label">Engellilik Dosyası</label>
                        <v-file-uploader
                            :disabled="!value.DisabledPerson"
                            :accept="['xlsx', 'png', 'jpg', 'doc', 'docx', 'xls', 'pdf', 'jpeg', 'txt']"
                            :value="value"
                            value-parameter="DisabilityFile"
                        ></v-file-uploader>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 mb-1">
            <div class="p-50 border rounded">
                <div class="row">
                    <div class="col-12">
                        <b-form-checkbox v-model="value.SurveillanceRequired">Takip Gerektiren Durum</b-form-checkbox>
                    </div>
                    <div class="col-12 my-1" v-if="value.SurveillanceRequired">
                        <label class="form-label">Takip Gerekçesi</label>
                        <v-select-list :disabled="!value.SurveillanceRequired" :options="reasons" placeholder="Takip Gerekçesi" v-model="reason" label="Name"></v-select-list>
                    </div>
                    <div class="col-12" v-if="value.SurveillanceRequired">
                        <label class="form-label">Takip Sıklığı</label>
                        <div class="row">
                            <div class="col-md-6 mb-1 mb-md-0">
                                <input type="number" class="form-control" v-model="value.SurveillanceFrequency" placeholder="Sıklık" />
                            </div>
                            <div class="col-md-6">
                                <select class="form-control" v-model="value.SurveillanceFrequencyUnit">
                                    <option :value="null" v-if="value.SurveillanceFrequencyUnit == null">Seçiniz</option>
                                    <option v-for="u in units" :key="u.value" :value="u.value">{{ u.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 mb-1">
            <b-form-checkbox v-model="value.CanWorkAtHeights">Yüksekte Çalışmaya Uygundur</b-form-checkbox>
        </div>
        <div class="col-12 mb-1">
            <b-form-checkbox v-model="value.CanWorkAtNightShift">Gece Vardiyasında Çalışabilir</b-form-checkbox>
        </div>
        <div class="col-12 mb-1">
            <b-form-checkbox v-model="value.DoctorApproval">Doktor Onayı</b-form-checkbox>
        </div>
        <div class="col-12">
            <label class="form-label">Sağlık Onayı Açıklaması</label>
            <textarea class="form-control resize-none" v-model="value.HealthApprovalDescription" rows="3" placeholder="Sağlık Onayı Açıklaması"></textarea>
        </div>
    </div>
</template>

<script>
import VFileUploader from "@/components/v-file-uploader/VFileUploader.vue";
import { BFormCheckbox } from "bootstrap-vue";
import HealthReportApi from "@/api/health-report";

export default {
    components: {
        VFileUploader,
        BFormCheckbox,
    },
    props: {
        value: Object,
    },
    data() {
        return {
            reasons: [],
            units: [
                { value: "G", name: "Gün" },
                { value: "A", name: "Ay" },
                { value: "Y", name: "Yıl" },
            ],
        };
    },
    mounted() {
        this.getReasons();
    },
    methods: {
        getReasons() {
            HealthReportApi.SurveillanceReason.List().then((res) => {
                this.reasons = res.data.Data || [];
            });
        },
    },
    computed: {
        reason: {
            get: function () {
                return this.reasons.find((b) => b.Id == this.value.HealthReportSurveillanceReasonId);
            },
            set: function (value) {
                this.value.HealthReportSurveillanceReasonId = value?.Id || null;
            },
        },
    },
};
</script>
